<template>
  <LcaTab :market="market" />
</template>

<script setup lang="ts">
import LcaTab from '~/components/LcaTab.vue'
import type { TMarketServiceConfig } from '~/src/types/markets'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  market: TMarketServiceConfig
}>()
</script>
